import { v4 as uuidv4 } from 'uuid';
import { TRACKING_EVENTS } from './constants';

export const canClientTrackEvent = (
  actions: Array<{ action: TRACKING_EVENTS }> = [],
  event: TRACKING_EVENTS,
) => {
  return actions.some(({ action }) => action === event);
};

export const generateUniqueTrackingId = (): string => {
  return uuidv4();
};
